import { BaseFileUploader } from '@/abstracts/base-file-uploader';
import { FileUploaderV1 } from '@/providers/file-uploaders/file-uploader.v1';
import type { FileVersion } from '@/store/file.interface';

export class FileUploaderFactory {
  private constructor() {}

  public static create(version: FileVersion): BaseFileUploader {
    switch (version) {
      case 'v2':
      default:
        return new FileUploaderV1(version);
    }
  }
}
